import { createSelector } from 'reselect';

import { State } from '@src/store/types';

const uiSelector = (state: State) => state.ui;

export const languageSelector = createSelector(
  uiSelector,
  ({ language }) => language
);

export const themeSelector = createSelector(uiSelector, ({ theme }) => theme);

export const snackBarSelector = createSelector(
  uiSelector,
  ({ snackBar }) => snackBar
);

export const primeHomeSelector = createSelector(
  uiSelector,
  ({ primeHome }) => primeHome
);

export const immigrationHomeSelector = createSelector(
  uiSelector,
  ({ immigrationHome }) => immigrationHome
);

export const tourHomeSelector = createSelector(
  uiSelector,
  ({ tourHome }) => tourHome
);

export const versionSelector = createSelector(
  uiSelector,
  ({ version }) => version
);

export const searchSelector = createSelector(
  uiSelector,
  ({ search }) => search
);

export const tourSearchSelector = createSelector(
  uiSelector,
  ({ tourSearch }) => tourSearch
);

export const tourFilterSelector = createSelector(
  uiSelector,
  ({ tourFilter }) => tourFilter
);

export const homeSelector = createSelector(uiSelector, ({ home }) => home);
